module.exports = __webpack_public_path__ + "static/media/icon-appyhere.0d5f9655.svg";